module.exports = __webpack_public_path__ + "static/media/sports4.59399940.jpg";